import React from "react";
import "./addproduct.css";

const QuestionnaireConfirmation = (props) => {
  const handleSubmit = () => {
    props.next(props.data);
  };

  return (
    <div>
      <div className="product-form-wrapper">
        <div className="product-information-wrapper">
          <h3 className="text-start">Questionnaire</h3>
          <p className="text-start">
            Please proceed to answer the questionnaire.
          </p>
        </div>
      </div>

      <div className="button-wrapper-product text-end">
        <button className="btn btn-outline-primary" onClick={handleSubmit}>
          Start Questionnaire
        </button>
      </div>
    </div>
  );
};

export default QuestionnaireConfirmation;